import { useDisciplineStore } from './store'
import { useDisciplineKanbanUrl } from './discipline-kanban-url.hook'

interface DisciplineGeneralLink {
  name: string
  url: string
}

interface DisciplineGeneralLinksReturn {
  refLinks: ComputedRef<DisciplineGeneralLink[]>
}

export const useDisciplineGeneralLinks = (): DisciplineGeneralLinksReturn => {
  const disciplineStore = useDisciplineStore()

  const refKanbanUrl = useDisciplineKanbanUrl(() => disciplineStore.getDetails)

  const refLinks = computed<DisciplineGeneralLink[]>(() => {
    const links = disciplineStore.getDetails?.links
    const candidates = [
      { name: 'Lesson', url: links?.lesson_url },
      { name: 'Kanban', url: refKanbanUrl.value },
      { name: 'Rebook', url: links?.rebook_url },
      { name: 'Pricing', url: links?.pricing_link },
    ]

    return candidates.filter((link): link is DisciplineGeneralLink => !!link.url)
  })

  return {
    refLinks,
  }
}
